__turbopack_context__.v({
  "customCursor": "ImageGallery-module__VAvE9W__customCursor",
  "emblaContainer": "ImageGallery-module__VAvE9W__emblaContainer",
  "emblaContainerInner": "ImageGallery-module__VAvE9W__emblaContainerInner",
  "emblaSlide": "ImageGallery-module__VAvE9W__emblaSlide",
  "emblaViewport": "ImageGallery-module__VAvE9W__emblaViewport",
  "galleryImage": "ImageGallery-module__VAvE9W__galleryImage",
  "imageWrapper": "ImageGallery-module__VAvE9W__imageWrapper",
  "section": "ImageGallery-module__VAvE9W__section",
});
